export const deleteAnyUser = (builder) => ({
    deleteAnyUser: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/delete_user',
                method: 'DELETE',
                body: body,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
              };
        },
    }),
});
